import {
    ErrorResponse,
    RestService,
} from "@sinossi/mates-react-library"

import {
    AssetProvenience,
    AssetWithImage,
    PaginatedResponse,
} from "models"

export interface GetRecentAssetsRequest {
    limit?: number
    provenance?: AssetProvenience | null
    daysBack?: number
}

export class RecentAssetsService {
    static getRecentAssets = (request: GetRecentAssetsRequest, callback: any, catchCallback: any) => {
        const requestBody = {
            limit: request.limit || 10,
            provenance: request.provenance,
            daysBack: request.daysBack || 30
        }

        RestService
            .post<PaginatedResponse<AssetWithImage>>("/api/assets/recent", requestBody)
            .then(callback)
            .catch(catchCallback)
    }
}